import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {  memo  , useCallback , useState , useRef} from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import {nl2br} from "../constants.js";
import { useTranslation } from "react-i18next";
import {getImagePaths , slickSettingsCard} from "../../components/constants.js";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import SlackImage from "../../components/modal/slackImage.js";
import { useAudio }  from "../../hooks/useAudio.ts";
import ShareButtonX from "..//button/ShareButtonX.js";
import LinkCopyButton from "..//button/LinkCopyButton.js";
import {getLink} from "../../utils/UrlUtil.js";

const MapCardHistory = memo((props) => {
    const {history , resetMarker , isRouteEnabled , inRouteGuid , toggleRouteGuid , modalOpen} = props;
    const [isOpenDescription , setIsOpenDescription] = useState(true); //default:true 常に表示
    const { t } = useTranslation();

    //--- 画像モーダル
    const [showModal , setShowModal] = useState(false);
    const selectedSlackImgUrl = useRef(null);
    const openSlackModal = (index, url) => {
        selectedSlackImgUrl.current = url;
        setShowModal(true);
    };
    const closeSlackModal = (index, url) => {
        selectedSlackImgUrl.current = "";
        setShowModal(false);
    };
    // 画像モーダル ---*/

    //---- 音声ガイド　---
    const { playSound, stopSound, currentAudioSrc } = useAudio();

    const toggleOpenDescription = () => {
        setIsOpenDescription(!isOpenDescription);
    };
    const clickBtnRouteGuid = () => {
        setIsOpenDescription(false);
        toggleRouteGuid(!inRouteGuid);
    }

    const close = () => {
        //setIsOpenDescription(false);
        stopSound();
        resetMarker();
    }
    const nl2comma = useCallback((str) => {
        return str.replaceAll("¥/", "、");
    },[]);

    const canDisplayDescription = (history) => {
        if(!history){
            return false;
        }
        return history.description !== '';
    };

    const soundStart = () => {
        let src = "/assets/sound/" + history.sound;
        playSound(src);
    };
    const soundStop = () => {
        stopSound();
    };
    const isPlayingSound = (history) => {
        return currentAudioSrc != ""
    }

    if(history && history.name){
    let paths = getImagePaths(history.path);
    return <>
    <Card className={"historyCard mapCard"} sx={{
       position: 'absolute',
       bottom: '1%',
       right:'1%',
       width:'98%',
       zIndex:10000     
    }}>
    <Box className='head-content'>
        <Typography component="div" variant="h5" className="title">
            {history.name}
        </Typography>
        <IconButton className={"close"} size="large">
            <CloseIcon onClick={close} />
        </IconButton>
    </Box>
    <Box className="share-button-row">
        <span className='category-label text'>{t("category." + history.category)}</span>
        <div className="img-wap">
            <ShareButtonX 
                path={getLink(history)}
                text={history.name + ' / ' + t("meta.title")}
            />
            <LinkCopyButton 
                path={getLink(history)}
            />
        </div>
    </Box>
    <hr className={"hr95"} />

    {!inRouteGuid &&
    <Box sx={{display:'flex'}}>
        <Box sx={{ display: 'block'}}>
            <CardContent className="card-content" sx={{ flex: '1 0 auto' }}>
                <div className="slick-wrap">
                    {paths.length >= 1 &&
                    <Slider {...slickSettingsCard}>
                    {
                        paths.map((path, index) =>{
                            return <Box className="img-carousel-wrap" key={index} onClick={() => openSlackModal(index, "/assets/images/descriptions/" + path)}>
                                <img className="img-carousel" src={"/assets/images/descriptions/" + path} />
                                </Box>
                        })
                    }
                    </Slider>
                    }
                </div>

                <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary', overflowWrap: 'break-word' }}>
                    <div dangerouslySetInnerHTML={{__html: nl2br(history.subtitle)}}></div>
                </Typography>

                {(history.insta360 || history.sound) && 
                <Box className='btnWrap'>
                    {history.insta360 && 
                    <Button variant="contained" onClick={modalOpen}>{t("360image.button")}</Button>
                    }
                    {history.sound && 
                    <>
                    {isPlayingSound(history)? (
                        <Button variant="contained" onClick={soundStop}>停止</Button>
                    ) : (
                        <Button variant="contained" onClick={soundStart}>音声ガイド</Button>
                    )}
                    </>
                    }
                </Box>
                }

                {canDisplayDescription(history) && !inRouteGuid &&
                <>
                <hr className={"hr98 mtb10"} />
                <Box className='description'>
                    <div dangerouslySetInnerHTML={{__html: nl2br(history.description)}}></div>
                </Box>
                </>
                }
            </CardContent>
        </Box>
    </Box>
    }

    <Box className='btnWrap'>
        {isRouteEnabled &&
        <Button variant="contained" onClick={clickBtnRouteGuid}>
            {inRouteGuid?<>{t("common.btn_off_Route")}</>:<>{t("common.btn_on_Route")}</>}
        </Button>
        }

        {
        //詳細ボタンは常に非表示
        false && canDisplayDescription(history) && !inRouteGuid &&
        <Button variant="outlined" onClick={toggleOpenDescription}>
            {isOpenDescription?<>{t("common.btn_close_detail")}</>:<>{t("common.btn_open_detail")}</>}
        </Button>
        }
    </Box>
    </Card>
    {showModal &&
        <SlackImage isOpen={showModal} modalClose={closeSlackModal} url={selectedSlackImgUrl.current}></SlackImage>
    }    
    </>;
    }
});
export default MapCardHistory
